import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";
import $ from "jquery";
import * as utils from "../../../utils.js";

export default class FormDatosDecesoHermana extends Component {
  constructor(props) {
    super(props);
    this.DatosDecesoPut = this.DatosDecesoPut.bind(this);
  }

  // Función que hace un put de los datos sacramentales de lamonja
  DatosDecesoPut(event) {
    event.preventDefault();
    let $this = $(this);
    let myform = document.getElementById("MyForm");
    let form = new FormData(myform);

    let settings = {
      url: process.env.REACT_APP_API_URL + "/hermanas/" + $this[0].props.DatosMonja.sister.id + "/deceso",
      method: "PUT",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };

    // En caso de exito los asigna al estado del componente monja detalle
    $.ajax(settings)
      .done(function (response) {
        $this[0].props.setAlert("", "Se han editado los datos correctamente", "success");
        response = JSON.parse(response);
        $this[0].props.setDatosHermana(response);
      })
      .fail($this[0].props.ErrorHandling);
  }

  render() {
    // Para obtener la fecha actual para la restriccion html
    let today = utils.calculateDate();
    // Default value lo establece del props de datos monja pasado en hermana detalles
    return (
      <Form className=" p-4" onSubmit={this.DatosDecesoPut} id="MyForm" autoComplete="off">
        <Form.Group>
          <Form.Row>
            <small className="mb-3">
              Los campos con un <b>*</b> deben de ser rellenados.
            </small>
          </Form.Row>
          <Form.Label>Fecha de Defunción *</Form.Label>
          <Form.Control type="date" name="decease" autoComplete="nope" required max={today} defaultValue={this.props.DatosMonja.sister ? this.props.DatosMonja.sister.decease : null} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Lugar de Defunción *</Form.Label>
          <Form.Control type="text" name="deceasePlace" autoComplete="nope" required maxLength="200" defaultValue={this.props.DatosMonja.sister ? this.props.DatosMonja.sister.deceasePlace : null} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Fecha de Entierro *</Form.Label>
          <Form.Control type="date" name="burial" autoComplete="nope" required max={today} defaultValue={this.props.DatosMonja.sister ? this.props.DatosMonja.sister.burial : null} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Lugar de Entierro *</Form.Label>
          <Form.Control type="text" name="burialPlace" autoComplete="nope" maxLength="200" required defaultValue={this.props.DatosMonja.sister ? this.props.DatosMonja.sister.burialPlace : null} />
        </Form.Group>
        <Form.Group>
          <Button
            type="submit"
            variant="outline-success"
            className="btn btn-block mt-5"
            //onClick={this.props.handleButtonShow} TODO
            name="Datos defunción"
          >
            Guardar
          </Button>
        </Form.Group>
      </Form>
    );
  }
}
